import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['wrap-with-overlay', $props.customClass])
  }, [$props.overlay ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 2);
}